export default "__VITE_ASSET__DOL6P1IH__"